import { createEntityStore } from '@redpanda/utils';
import { toast } from 'react-hot-toast';
import { getJournalEntries, deleteJournalEntry as deleteJournalEntryApi } from '../services/api';
import { storeMessages } from './storeMessages';

export interface JournalEntryDetail {
  id: string;
  accountId: string;
  debitAmount: number | string;
  creditAmount: number | string;
  description?: string | null;
  account?: { id: string; code: string; name: string; type: string };
}

export interface JournalEntry {
  id: string;
  userId: string; // 建立者（一般使用者只能改、刪自己的）
  date: string;
  description: string;
  reference?: string | null;
  totalAmount: number | string;
  isPosted: boolean;
  /** 發票自動產生的分錄（INVOICE、INVOICE_VOID、INVOICE_PAYMENT）：只能從發票改 */
  source?: string | null;
  details: JournalEntryDetail[];
  createdAt?: string;
  updatedAt?: string;
}

export const useJournalStoreBase = createEntityStore<JournalEntry>({
  entityName: 'journal',
  fetchFn: (page: number) => getJournalEntries(page),
  deleteFn: deleteJournalEntryApi,
  toast,
  messages: storeMessages,
});
